export default __webpack_public_path__ + "static/media/push-img.58013ec5.svg";